import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ColumnButton } from 'lib/components/ColumnButton';
import { MAIN_ROUTES } from 'router/routes';
import { getDynamicRoute } from 'lib/frontend/utils/router';

export default function LoginUserFooter() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '';
  return (
    <div className="mb-24">
      <div className="mt-6">
        <div className="relative flex justify-center text-base leading-5">
          <hr className="flex-1 text-column-gray-400 mt-3 px-10" />
          <p className="flex-auto text-center text-column-gray-500 text-base">
            Don't have an account?
          </p>
          <hr className="flex-1 text-column-gray-400 mt-3 px-10  " />
        </div>
      </div>
      <div className="mt-6">
        <ColumnButton
          tertiary
          type="button"
          onClick={() =>
            navigate(
              getDynamicRoute(
                MAIN_ROUTES.REGISTER,
                {},
                redirect ? { redirect } : undefined
              )
            )
          }
          buttonText="Register"
          id="register-button"
          fullWidth
          size="lg"
        />
      </div>
    </div>
  );
}
